import { render, staticRenderFns } from "./MgeoreptypesForm.vue?vue&type=template&id=8c703422"
import script from "./MgeoreptypesForm.vue?vue&type=script&lang=js"
export * from "./MgeoreptypesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports